/* The Haaland Code — product page variant sync and media gallery. Named
   hc-product-form.js (not product-form.js) to avoid overwriting Horizon's
   own stock product-form.js used elsewhere in the theme. The quick
   format-selector modal lives in hc-format-modal.js since it's needed
   site-wide, not just on the product page. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function setLoading(btn, loading) {
    if (!btn) return;
    if (loading) btn.setAttribute('data-loading', 'true');
    else btn.removeAttribute('data-loading');
  }

  function initProductForm() {
    const root = document.querySelector('[data-hc-product-form]');
    if (!root) return;
    const dataEl = root.querySelector('[data-hc-variants-json]');
    if (!dataEl) return;

    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    const radios = root.querySelectorAll('[data-hc-variant-radio]');
    const priceEl = root.querySelector('[data-hc-price]');
    const compareEl = root.querySelector('[data-hc-compare-price]');
    const availabilityEl = root.querySelector('[data-hc-availability]');
    const addToCartBtn = root.querySelector('[data-hc-add-to-cart]');
    const orderNowBtn = root.querySelector('[data-hc-order-now]');
    const hiddenIdInput = root.querySelector('[data-hc-variant-id-input]');
    const mediaMain = document.querySelector('[data-hc-product-media-main] img');
    const errorEl = root.querySelector('[data-hc-product-error]');
    const isPreorder = root.getAttribute('data-preorder') === 'true';
    const availabilityMessage = root.getAttribute('data-availability-message');

    function findVariant(id) {
      return variants.find(function (v) {
        return String(v.id) === String(id);
      });
    }

    function applyVariant(variant, opts) {
      opts = opts || {};
      if (!variant) return;

      if (hiddenIdInput) hiddenIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.priceFormatted;

      if (compareEl) {
        if (variant.compareAtFormatted && variant.compareAtCents > variant.priceCents) {
          compareEl.textContent = variant.compareAtFormatted;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (availabilityEl) {
        availabilityEl.classList.remove('hc-product__availability--sold-out', 'hc-product__availability--preorder');
        if (!variant.available) {
          availabilityEl.textContent = 'Sold out';
          availabilityEl.classList.add('hc-product__availability--sold-out');
        } else if (isPreorder) {
          availabilityEl.textContent = availabilityMessage || 'Available for preorder';
          availabilityEl.classList.add('hc-product__availability--preorder');
        } else {
          availabilityEl.textContent = '';
        }
      }

      [addToCartBtn, orderNowBtn].forEach(function (btn) {
        if (!btn) return;
        if (!variant.available) {
          btn.setAttribute('aria-disabled', 'true');
          btn.disabled = true;
        } else {
          btn.removeAttribute('aria-disabled');
          btn.disabled = false;
        }
        if (btn.hasAttribute('data-hc-direct-buy')) {
          btn.setAttribute('data-variant-id', variant.id);
          btn.setAttribute('data-needs-selector', 'false');
        }
      });

      if (mediaMain && variant.featuredImage && !opts.skipImage) {
        mediaMain.src = variant.featuredImage;
      }

      if (errorEl) errorEl.textContent = '';

      if (!opts.skipTracking && window.HC) {
        window.HC.track('product_variant_selected', { variant_id: variant.id });
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        applyVariant(findVariant(radio.value));
      });
    });

    const qtyInput = root.querySelector('[data-hc-add-to-cart-form] input[type="number"]');
    const qtyDecrease = root.querySelector('[data-hc-qty-decrease]');
    const qtyIncrease = root.querySelector('[data-hc-qty-increase]');
    if (qtyInput && qtyDecrease && qtyIncrease) {
      qtyDecrease.addEventListener('click', function () {
        const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = next;
      });
      qtyIncrease.addEventListener('click', function () {
        const next = (parseInt(qtyInput.value, 10) || 1) + 1;
        qtyInput.value = next;
      });
    }

    const addToCartForm = root.querySelector('[data-hc-add-to-cart-form]');
    if (addToCartForm) {
      addToCartForm.addEventListener('submit', function (event) {
        event.preventDefault();
        if (addToCartBtn && (addToCartBtn.getAttribute('aria-disabled') === 'true' || addToCartBtn.disabled)) return;
        const variantId = hiddenIdInput ? hiddenIdInput.value : null;
        if (!variantId) return;
        const quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

        setLoading(addToCartBtn, true);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] }),
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (data) {
                throw new Error((data && data.description) || 'Could not add this item to your cart.');
              });
            }
            return res.json();
          })
          .then(function () {
            if (window.HC) window.HC.track('product_add_to_cart', { variant_id: variantId });
            document.dispatchEvent(new CustomEvent('hc:cart:updated'));
            document.dispatchEvent(new CustomEvent('hc:cart:open'));
          })
          .catch(function (err) {
            if (errorEl) errorEl.textContent = err.message;
          })
          .finally(function () {
            setLoading(addToCartBtn, false);
          });
      });
    }

    const checked = root.querySelector('[data-hc-variant-radio]:checked');
    if (checked) applyVariant(findVariant(checked.value), { skipImage: true, skipTracking: true });
  }

  /* Swaps the main product image when a gallery thumbnail is clicked. */
  function initGallery() {
    const mainImg = document.querySelector('[data-hc-product-media-main] img');
    const thumbs = document.querySelectorAll('[data-hc-thumb]');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const thumbImg = thumb.querySelector('img');
        if (!thumbImg) return;
        mainImg.src = thumbImg.src.replace(/width=\d+/, 'width=1200');
        mainImg.srcset = '';
      });
    });
  }

  ready(function () {
    initProductForm();
    initGallery();
  });
})();
